import React, { useEffect } from 'react';
import { Button, Form, Input, Spin } from 'antd';

const AdminUserForm = ({ handleSubmit, action, user, handleCancel, isFetching }) => {
  const [form] = Form.useForm();

  const onFinishForm = (values) => {
    handleSubmit && handleSubmit(values);
  };

  useEffect(() => {
    if (action === 'new') {
      form.setFieldsValue({ giveName: null, familyName: null, email: null, password: null });
    } else if (user) {
      // Split user.name into giveName and familyName for the form
      const nameParts = (user.name || '').split(' ');
      const giveName = nameParts[0] || '';
      const familyName = nameParts.slice(1).join(' ') || '';
      form.setFieldsValue({
        giveName,
        familyName,
        email: user.email,
      });
    }
  }, [action, user]);

  return (
    <Spin spinning={isFetching}>
      <div className="RiderForm">
        <div className="FormHeader"></div>
        <div className="FormContent">
          <Form
            form={form}
            scrollToFirstError
            layout="vertical"
            requiredMark={false}
            colon={false}
            onFinish={onFinishForm}
          >
            <Form.Item label="First Name" name="giveName" rules={[{ required: true, message: 'Required' }]}>
              <Input placeholder="First Name" />
            </Form.Item>
            <Form.Item label="Last Name" name="familyName" rules={[{ required: true, message: 'Required' }]}>
              <Input placeholder="Last Name" />
            </Form.Item>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Required' },
                { type: 'email', message: 'Invalid Email' },
              ]}
            >
              <Input placeholder="Email" />
            </Form.Item>
            <Form.Item label="Password" name="password" rules={[{ required: action === 'new', message: 'Required' }]}>
              <Input.Password
                placeholder={action === 'new' ? 'Password' : 'Leave blank to keep current'}
                autoComplete="new-password"
              />
            </Form.Item>
          </Form>
        </div>
        <div className="FormFooter">
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>
          <Button type="primary" block size="large" onClick={() => form.submit()}>
            {action === 'new' ? 'Create' : 'Update'}
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default AdminUserForm;
